 <div class="timer-overlay">
      <div class="timer-content">
        <div class="timer-countdown">{{ remainingTime }}</div>
        <div class="timer-message">Please wait...</div>
      </div>
    </div>
